import { CSSProperties, styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

type DropdownItem = {
  title: string;
  desc: string;
  className?: string;
};

export type AccordionProps = {
  items: DropdownItem[];
  style?: CSSProperties;
  className?: string;
};

export const Root = styled.div`
  border-radius: 12px;
  background: ${uiToken.color.background.glass};
  border: 0.5px solid ${uiToken.color.background.glass};
  white-space: pre-wrap;
  overflow: hidden;
`;

export const Separator = styled.div`
  height: 0.5px;
  background: rgba(255, 255, 255, 0.1);
  margin: 0 16px;
`;
